<script lang="ts">
  // Icons for the phone bottom nav. Inline SVG rather than emoji or a glyph
  // font: emoji render at wildly different sizes (and in fixed colours) across
  // iOS and Android, and half the geometric glyphs the app uses elsewhere fall
  // back to a box on one platform or the other. These inherit currentColor, so
  // they follow the active/inactive tab colour in every palette.
  import type { ViewKind } from "../lib/stores";

  let { kind, size = 22 }: { kind: ViewKind; size?: number } = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="1.9"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
  focusable="false"
>
  {#if kind === "calendar"}
    <rect x="3" y="5" width="18" height="16" rx="4" />
    <path d="M3 10h18M8 3v4M16 3v4" />
    <path d="M8 14h2M14 14h2M8 17.5h2" />
  {:else if kind === "timeline"}
    <path d="M3 6h18M3 12h18M3 18h11" />
    <circle cx="7" cy="6" r="1.6" fill="currentColor" stroke="none" />
    <circle cx="14" cy="12" r="1.6" fill="currentColor" stroke="none" />
    <circle cx="10" cy="18" r="1.6" fill="currentColor" stroke="none" />
  {:else if kind === "events"}
    <path d="M12 3.2 14.6 9l6.4.6-4.8 4.2 1.4 6.2L12 16.8 6.4 20l1.4-6.2L3 9.6 9.4 9z" />
  {:else}
    <path d="M4 6.5h11M4 12h11M4 17.5h7" />
    <path d="M18 4.8 19.4 6.2 22 3.6" />
    <path d="M18 10.3 19.4 11.7 22 9.1" />
  {/if}
</svg>

<style>
  svg {
    display: block;
    flex: 0 0 auto;
  }
</style>
